var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    { class: this.sidemenu_minimized, attrs: { id: "sidebar" } },
    [
      _c("div", { staticClass: "sidebar-header" }, [
        _c(
          "div",
          {
            staticStyle: { "margin-top": "65px", "margin-left": "5px" },
            on: {
              click: function($event) {
                return _vm.toggleToIcons()
              }
            }
          },
          [
            _c("i", { staticClass: "fa fa-bars fa-1x" }),
            _vm._v(" "),
            _c("span", { staticClass: "menu-item-name app-heading" }, [
              _vm._v("Mentoring")
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("ul", { staticClass: "list-unstyled" }, [
        _c(
          "li",
          { staticClass: "active" },
          [
            _c("router-link", { attrs: { to: "/admin-dashboard" } }, [
              _c("i", { staticClass: "fa fa-home" }),
              _vm._v(" "),
              _c("span", { staticClass: "menu-item-name" }, [_vm._v("Home")])
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          [
            _c(
              "router-link",
              {
                class: [
                  _vm.currentPage.includes(
                    "account-lookup",
                    "account-lookup/view-list"
                  )
                    ? _vm.activeClass
                    : ""
                ],
                attrs: { to: "/account-lookup" }
              },
              [
                _c("i", { staticClass: "fa fa-user-o" }),
                _vm._v(" "),
                _c("span", { staticClass: "menu-item-name" }, [
                  _vm._v("Account Lookup")
                ])
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          [
            _c(
              "router-link",
              {
                class: [
                  _vm.currentPage.includes(
                    "enterprise-lookup",
                    "enterprise-lookup/view-list"
                  )
                    ? _vm.activeClass
                    : ""
                ],
                attrs: { to: "/enterprise-lookup" }
              },
              [
                _c("i", { staticClass: "fa fa-users" }),
                _vm._v(" "),
                _c("span", { staticClass: "menu-item-name" }, [
                  _vm._v("Enterprise Lookup")
                ])
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          [
            _c(
              "router-link",
              { attrs: { to: "/customer-accounts-view-list" } },
              [
                _c("i", { staticClass: "fa fa-user-o" }),
                _vm._v(" "),
                _c("span", { staticClass: "menu-item-name" }, [
                  _vm._v("New Accounts")
                ])
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          [
            _c("router-link", { attrs: { to: "/view-affiliate-list" } }, [
              _c("i", { staticClass: "fa fa-connectdevelop" }),
              _vm._v(" "),
              _c("span", { staticClass: "menu-item-name" }, [
                _vm._v("Affiliate Manager")
              ])
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          [
            _c("router-link", { attrs: { to: "/list-accounts" } }, [
              _c("i", { staticClass: "fa fa-list-alt" }),
              _vm._v(" "),
              _c("span", { staticClass: "menu-item-name" }, [
                _vm._v("Mentors/Mentees")
              ])
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          [
            _c("router-link", { attrs: { to: "/listusers" } }, [
              _c("i", { staticClass: "fa fa-list" }),
              _vm._v(" "),
              _c("span", { staticClass: "menu-item-name" }, [
                _vm._v("List Users")
              ])
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          [
            _c("router-link", { attrs: { to: "/add-account" } }, [
              _c("i", { staticClass: "fa fa-user" }),
              _vm._v(" "),
              _c("span", { staticClass: "menu-item-name" }, [
                _vm._v("Add Account")
              ])
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          [
            _c("router-link", { attrs: { to: "/add-admin" } }, [
              _c("i", { staticClass: "fa fa-user-secret" }),
              _vm._v(" "),
              _c("span", { staticClass: "menu-item-name" }, [
                _vm._v("Add Master Admin")
              ])
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          [
            _c("router-link", { attrs: { to: "/add-researcher" } }, [
              _c("i", { staticClass: "fa fa-user" }),
              _vm._v(" "),
              _c("span", { staticClass: "menu-item-name" }, [
                _vm._v("Add Researcher")
              ])
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          [
            _c("router-link", { attrs: { to: "/add-csr" } }, [
              _c("i", { staticClass: "fa fa-user" }),
              _vm._v(" "),
              _c("span", { staticClass: "menu-item-name" }, [_vm._v("Add CSR")])
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          [
            _c("router-link", { attrs: { to: "/naics-list" } }, [
              _c("i", { staticClass: "fa fa-list-ol" }),
              _vm._v(" "),
              _c("span", { staticClass: "menu-item-name" }, [
                _vm._v("NAICS Manager")
              ])
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          [
            _c("router-link", { attrs: { to: "/notification-manager-list" } }, [
              _c("i", { staticClass: "fa fa-list-ol" }),
              _vm._v(" "),
              _c("span", { staticClass: "menu-item-name" }, [
                _vm._v("Notification Manager")
              ])
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          [
            _c("router-link", { attrs: { to: "/subscription-list" } }, [
              _c("i", { staticClass: "fa fa-list-ol" }),
              _vm._v(" "),
              _c("span", { staticClass: "menu-item-name" }, [
                _vm._v("Manage Subscriptions")
              ])
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          [
            _c("router-link", { attrs: { to: "/course-list" } }, [
              _c("i", { staticClass: "fa fa-list-ol" }),
              _vm._v(" "),
              _c("span", { staticClass: "menu-item-name" }, [
                _vm._v("Manage Course")
              ])
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          [
            _c("router-link", { attrs: { to: "/import/prospect-accounts" } }, [
              _c("i", { staticClass: "fa fa-list-ol" }),
              _vm._v(" "),
              _c("span", { staticClass: "menu-item-name" }, [
                _vm._v("Import Accounts")
              ])
            ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "list-unstyled" },
        [
          _c(
            "li",
            { staticClass: "active" },
            [
              _c(
                "b-link",
                {
                  directives: [
                    {
                      name: "b-toggle",
                      rawName: "v-b-toggle",
                      value: "collapse-buildable-submenu",
                      expression: "'collapse-buildable-submenu'"
                    }
                  ]
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/buildable-items-icon.png"),
                      width: "25",
                      height: "25",
                      alt: "Buildable Items"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "menu-item-name" }, [
                    _vm._v("Buildable Items\n     "),
                    _c("i", {
                      staticClass: "fa fa-angle-down report-dropdown",
                      staticStyle: { "font-size": "20px" }
                    })
                  ])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("b-collapse", { attrs: { id: "collapse-buildable-submenu" } }, [
            _c("ul", { staticClass: "nav flex-column ml-3" }, [
              _c(
                "li",
                [
                  _c("router-link", { attrs: { to: "/view-tasklist" } }, [
                    _c("i", { staticClass: "fa fa-tasks" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "menu-item-name" }, [
                      _vm._v("Task Lists")
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                [
                  _c("router-link", { attrs: { to: "/task-library" } }, [
                    _c("i", { staticClass: "fa fa-book" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "menu-item-name" }, [
                      _vm._v("Task Library")
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                [
                  _c(
                    "router-link",
                    { attrs: { to: "/assessment-builder-list" } },
                    [
                      _c("i", { staticClass: "fa fa-list-ol" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "menu-item-name" }, [
                        _vm._v("Assessments")
                      ])
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                [
                  _c(
                    "router-link",
                    { attrs: { to: "/assessment-section-list" } },
                    [
                      _c("i", { staticClass: "fa fa-list-ol" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "menu-item-name" }, [
                        _vm._v("Assessment Sections")
                      ])
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                [
                  _c("router-link", { attrs: { to: "/forms-manager" } }, [
                    _c("i", { staticClass: "fa fa-list-ol" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "menu-item-name" }, [
                      _vm._v("Forms Manager")
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                [
                  _c(
                    "router-link",
                    { attrs: { to: "/introduction-manager-list" } },
                    [
                      _c("i", { staticClass: "fa fa-list-ol" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "menu-item-name" }, [
                        _vm._v("Introduction Manager")
                      ])
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                [
                  _c(
                    "router-link",
                    { attrs: { to: "/view-certification-manager" } },
                    [
                      _c("i", { staticClass: "fa fa-list-ol" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "menu-item-name" }, [
                        _vm._v("Certification Manager")
                      ])
                    ]
                  )
                ],
                1
              )
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "heading-seperator" }),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "list-unstyled" },
        [
          _c(
            "li",
            { staticClass: "active" },
            [
              _c(
                "b-link",
                {
                  directives: [
                    {
                      name: "b-toggle",
                      rawName: "v-b-toggle",
                      value: "collapse-report-submenu",
                      expression: "'collapse-report-submenu'"
                    }
                  ]
                },
                [
                  _c("i", { staticClass: "fa fa-line-chart" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "menu-item-name" }, [
                    _vm._v("Reports\n         "),
                    _c("i", {
                      staticClass: "fa fa-angle-down report-dropdown",
                      staticStyle: { "font-size": "20px" }
                    })
                  ])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("b-collapse", { attrs: { id: "collapse-report-submenu" } }, [
            _c("ul", { staticClass: "nav flex-column ml-3" }, [
              _c(
                "li",
                [
                  _c("router-link", { attrs: { to: "/account-report" } }, [
                    _c("i", { staticClass: "fa fa-user-o" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "menu-item-name" }, [
                      _vm._v("Account Report")
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nav-item" },
                [
                  _c(
                    "router-link",
                    { attrs: { to: "/account-contact-report" } },
                    [
                      _c("i", { staticClass: "fa fa-user-o" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "menu-item-name" }, [
                        _vm._v("Account Contact Report")
                      ])
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nav-item" },
                [
                  _c("router-link", { attrs: { to: "/activity-report" } }, [
                    _c("i", { staticClass: "fa fa-user-o" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "menu-item-name" }, [
                      _vm._v("Activity Report")
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nav-item" },
                [
                  _c("router-link", { attrs: { to: "/flash-report" } }, [
                    _c("i", { staticClass: "fa fa-user-o" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "menu-item-name" }, [
                      _vm._v("Flash Report")
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nav-item" },
                [
                  _c("router-link", { attrs: { to: "/usage-report" } }, [
                    _c("i", { staticClass: "fa fa-user-o" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "menu-item-name" }, [
                      _vm._v("Usage Report")
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                { staticClass: "nav-item" },
                [
                  _c("router-link", { attrs: { to: "/mentee-report" } }, [
                    _c("i", { staticClass: "fa fa-user-o" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "menu-item-name" }, [
                      _vm._v("Mentee Report")
                    ])
                  ])
                ],
                1
              )
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("ul", { staticClass: "list-unstyled list-signout-menu" }, [
        _c(
          "li",
          [
            _c("router-link", { attrs: { to: "/logout" } }, [
              _c("i", { staticClass: "fa fa-sign-out" }),
              _vm._v(" "),
              _c("span", { staticClass: "menu-item-name" }, [
                _vm._v("Sign Out")
              ])
            ])
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-67b946be", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67b946be","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/masteradmin_sidebar_menu.vue
// module id = null
// module chunks = 